import { PopoverContent } from './CommercialProductContent.js';
import { t } from '../../../common/i18n/index.js';

export const ManagedServicePopoverContent = () => (
  <PopoverContent>
    <div>{t.AG7I('If the device is damaged, you will receive a new one immediately.')}</div>
  </PopoverContent>
);
